<template>
	<v-container>


				<nav class="navi main-nav">
					<ul>
						<li>
							<router-link :to="{ name: 'CSRConnectionsList' }" >TABLE</router-link>
						</li>
						<li>
							<router-link :to="{ name: 'Connections Sustainability CSRConnectionsMap' }"> MAP</router-link>
						</li>
					</ul>
				</nav>

			<router-view />

	</v-container>
</template>

<script>
export default {
	data() {
		return {
			EsgYear: [],
			selectedYear: null
		}
	},
	created() {
		const currentYear = new Date().getFullYear()
		for (let year = currentYear; year >= currentYear - 5; year--) {
			this.EsgYear.push(year)
		}
	},
	watch: {
		selectedYear(selectyear){
			this.selectedYear = selectyear
		}
	},
}
</script>

<style scoped>

.navi ul {
	margin: 0;
}

.navi li {
	display: inline;
}

.navi a {
	display: inline-block;
	padding: 0.5em;
	font: inherit;
	margin: 10px;
	text-decoration: none;
	font-weight: bolder;
	color: gray;
}

.navi a:hover {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}

.main-nav {
	width: auto;
	text-align: center;
	font-size: 1.2em;
	margin-top: 0;
	padding: 15px 0;
}

.main-nav li {
	padding: 0;
}

a.router-link-active {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}
</style>